module.exports = __webpack_public_path__ + "static/media/pic2.e883363e.jpg";